module.exports = __webpack_public_path__ + "img/scan.ea504b49.svg";